import { useTranslation } from 'react-i18next'

import { useTypedLocation } from '@/hooks/use-typed-location'
import { Page } from '@/layouts/page'
import { EnvioDocumentos, listaDocumentosPessoaFisica, selectRecuperarDocumentos } from '@/shared/envio-documentos'

import { useEnviarDocumentosLead } from '../../hooks/use-enviar-documentos-lead'
import { GetDocumentosLeadRepresadoService } from '../../http/get-documentos-lead-represado.service'
import type { TLeadRepresadoDetalhes } from '../../http/get-lead-represado-por-id.service'
import { leadsRepresadosQueryKeys } from '../../utils/query-keys'

export const EnvioDocumentosLeadsPage = () => {
  const { state } = useTypedLocation<{ pessoa: TLeadRepresadoDetalhes }>()
  const { mutateAsync: enviarDocumento } = useEnviarDocumentosLead(state.pessoa.id)
  const { t } = useTranslation('leads-represados')

  return (
    <Page
      breadcrumb={[
        { label: t('pages.consulta.breadcrumb'), to: '/leads-represados' },
        { label: t('pages.detalhes.breadcrumb'), to: `/leads-represados/${state.pessoa.id}` },
        { label: t('pages.envio_documentos.breadcrumb') },
      ]}
    >
      <Page.Main>
        <Page.Header>
          <Page.Title>{t('pages.envio_documentos.titulo')}</Page.Title>
          <Page.Description>{t('pages.envio_documentos.descricao')}</Page.Description>
        </Page.Header>
        <Page.Section>
          <EnvioDocumentos
            config={{
              pessoa: { tipo: 'lead_represado', nome: state.pessoa.nome, documento: state.pessoa.cpf },
              documentTypes: listaDocumentosPessoaFisica.toSorted((a, b) => a.label.localeCompare(b.label)),
              backButtonText: 'Lista de leads',
              enviarDocumentoMutation: enviarDocumento,
              recuperarDocumentosQuery: {
                gcTime: 0,
                staleTime: 0,
                queryKey: leadsRepresadosQueryKeys.documentosLead(state.pessoa.id),
                queryFn: async () =>
                  new GetDocumentosLeadRepresadoService().execute(state.pessoa.id).then((response) => response.data),
                select: selectRecuperarDocumentos,
              },
            }}
          >
            <EnvioDocumentos.Header />
            <EnvioDocumentos.Form />
            <EnvioDocumentos.List />
          </EnvioDocumentos>
        </Page.Section>
      </Page.Main>
    </Page>
  )
}
